export const HOME = {
  path: "",
  get fullUrl() {
    return `/${this.path}`;
  },
};

export const LOGIN = {
  path: "login",
  get fullUrl() {
    return `/${this.path}`;
  },
};

export const USERS = {
  path: "users",
  get fullUrl() {
    return `/${this.path}`;
  },
};

export const PHOTOS = {
  path: "photos",
  get fullUrl() {
    return `/${this.path}`;
  },
};

export const ERRORS = {
  path: "errors",
  get fullUrl() {
    return `/${this.path}`;
  },
};

export const INSIGHTS = {
  path: "insights",
  get fullUrl() {
    return `/${this.path}`;
  },
};

export const USERS_SUBSCRIPTION = {
  path: "users-subscription",
}

export const USER_DISPUTE_REQUESTS = {
  path: 'dispute-requests',
  get fullUrl() {
    return `/${this.path}`
  }
}

export const SUBSCRIPTION = {
  path: "subscription",
  get fullUrl() {
    return `/${this.path}`;
  },
};

export const SUBSCRIPTION_CREATE = {
  path: "create",
  get fullUrl() {
    return `${SUBSCRIPTION.fullUrl}/${this.path}`;
  },
};
export const SUBSCRIPTION_INTEREST = {
  path: "interest",
  get fullUrl() {
    return `${SUBSCRIPTION.fullUrl}/${this.path}`;
  },
};

export const DOCUMENT_VERIFICATION = {
  path: 'document-verification',
  get fullUrl() {
    return `/${this.path}`
  }
}


export const CHATS = {
  path: "chats",
  get fullUrl() {
    return `/${this.path}`;
  },
};
